import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ejemplo-botones',
  templateUrl: './ejemplo-botones.component.html',
  styleUrls: ['./ejemplo-botones.component.scss']
})
export class EjemploBotonesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
